import * as React from 'react'
import { App } from "./App";
import { Main } from "@commons/Componentes/MainPanel";
import { getComponentWithLoading } from "@commons/Utils";
import { MiCuenta } from "@commons/Views/MiCuenta/MiCuenta";
const getComponent = (component) => {
    return getComponentWithLoading(component)();
  };
  
export const routes = [
    {
        path: "/",
        element: <App/>,
        children: [
            {
                path: "/App/Seguridad/MiCuenta",
                element: <MiCuenta />,
            },
            {
                path: "/",
                element: <Main />,
                index: true
            },
            {
                path: "*",
                element:  <Main />,
            }
        ],
    },
];

